import { memo } from 'react';
import { CircularProgress, styled } from '@mui/material';

const Wrapper = styled('div')(() => ({
  display: 'flex',
  height: '100vh',
  alignItems: 'center',
  justifyContent: 'center',
}));

export const Splash = memo(() => (
  <Wrapper>
    <CircularProgress />
  </Wrapper>
));
